import { call, put, takeEvery } from 'redux-saga/effects';
import { getBikeModels } from '../../requests/get_all_bikes_request';
import { getBikeModelsRequestSuccess, getBikeModelsRequestFailure } from '../actions/get_bike_models.actions';
import { GET_BIKE_MODELS_REQUEST } from '../constants/bike_model.constants';
import { message_error } from '../../../../../components/Message';

function* getBikeModelsRequest({ where, pagination: { pageSize, page } }) {
    const { result, options, error } = yield call(getBikeModels, where, pageSize, (page !== 0 ? page - 1 : page) * pageSize);
    if (result) {
        yield put(getBikeModelsRequestSuccess({ data: options, pagination: { pageSize, page } }));
    } else {
        yield put(getBikeModelsRequestFailure(error.message));
        message_error(error.message);
    }
}

export default function* modelsSaga() {
    yield takeEvery(GET_BIKE_MODELS_REQUEST, getBikeModelsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/sagas/get_bike_models.saga.js